import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/pro-regular-svg-icons';

export const BurgerMenuIcon = () => (
    <div className="burgermenu-icon-container">
        <div className="burgermenu-icon" >
            <FontAwesomeIcon icon={faBars} />
        </div>
    </div>
)
export default BurgerMenuIcon;




// WEBPACK FOOTER //
// ./src/components/icons/BurgerMenuIcon.js